/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  WHITELIST_USER: {},
};

const MACHINE_CONFIG = {
  id: "io.vlinder.tribe.WHITELIST.user",
  initial: "idle",
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ["resetAction"],
      on: {
        START: { target: "WHITELIST_USER" },
      },
    },
    WHITELIST_USER: {
      invoke: {
        id: "whitelistUser",
        src: "whitelistUser",
        onDone: {
          target: "WHITELIST_USER_SUCCESS",
          actions: ["successAction"],
        },
        onError: {
          target: "WHITELIST_USER_FAILED",
          actions: ["failureAction"],
        },
      },
    },
    WHITELIST_USER_SUCCESS: {
      on: {
        START: { target: "WHITELIST_USER" },
      },
    },
    WHITELIST_USER_FAILED: {
      on: {
        START: { target: "WHITELIST_USER" },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
